"use strict";

var _classCallCheck = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("D:\\Dropbox\\projects\\justinireland.com\\justinirelandcom-cra\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatableColor = void 0;

var OptionsColor_1 = require("./OptionsColor");

var HslAnimation_1 = require("./HslAnimation");

var AnimatableColor =
/*#__PURE__*/
function (_OptionsColor_1$Optio) {
  _inherits(AnimatableColor, _OptionsColor_1$Optio);

  function AnimatableColor() {
    var _this;

    _classCallCheck(this, AnimatableColor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnimatableColor).call(this));
    _this.animation = new HslAnimation_1.HslAnimation();
    return _this;
  }

  _createClass(AnimatableColor, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(AnimatableColor.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      var colorAnimation = data.animation;

      if (colorAnimation !== undefined) {
        if (colorAnimation.enable !== undefined) {
          this.animation.h.load(colorAnimation);
        } else {
          this.animation.load(data.animation);
        }
      }
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = new AnimatableColor();
      color.load(source);

      if (data !== undefined) {
        if (typeof data === "string" || data instanceof Array) {
          color.load({
            value: data
          });
        } else {
          color.load(data);
        }
      }

      return color;
    }
  }]);

  return AnimatableColor;
}(OptionsColor_1.OptionsColor);

exports.AnimatableColor = AnimatableColor;